(() => {
  if (window.__bzQuickAdd) return;
  window.__bzQuickAdd = true;

  const root = () => (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  const currency = () => (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'GBP';
  const money = (cents) => {
    try {
      return new Intl.NumberFormat(document.documentElement.lang || undefined, { style: 'currency', currency: currency() }).format(cents / 100);
    } catch (error) {
      return (cents / 100).toFixed(2);
    }
  };
  const sized = (src, width) => (src ? src + (src.includes('?') ? '&' : '?') + 'width=' + width : '');
  const plusIcon = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M12 5v14M5 12h14"/></svg>';

  /* ---------- Cart drawer enhancements: themed Add buttons + accepted payments ---------- */
  function enhanceCart() {
    const drawer = document.querySelector('cart-drawer');
    if (!drawer) return;
    drawer.querySelectorAll('.bezelor-cart-upsell__form button:not(.bz-upsell-add)').forEach((button) => {
      button.classList.add('bz-upsell-add');
      button.disabled = false;
      button.innerHTML = '<span class="bz-upsell-add__plus" aria-hidden="true">' + plusIcon + '</span><span>Add</span>';
      const title = button.closest('.bezelor-cart-upsell')?.querySelector('.bezelor-cart-upsell__title')?.textContent.trim();
      if (title) button.setAttribute('aria-label', 'Choose options for ' + title);
      button.setAttribute('aria-haspopup', 'dialog');
    });
    const ctas = drawer.querySelector('.cart__ctas');
    const template = document.getElementById('BzPayIcons');
    if (ctas && template && !drawer.querySelector('.bz-cart-pay')) ctas.after(template.content.cloneNode(true));
  }

  let queued = false;
  const queueEnhance = () => {
    if (queued) return;
    queued = true;
    requestAnimationFrame(() => {
      queued = false;
      enhanceCart();
    });
  };

  function watchCart() {
    enhanceCart();
    const drawer = document.querySelector('cart-drawer');
    if (drawer && !drawer.dataset.bzWatched) {
      drawer.dataset.bzWatched = 'true';
      new MutationObserver(queueEnhance).observe(drawer, { childList: true, subtree: true });
    }
  }

  /* ---------- Variant picker sheet ---------- */
  let dialog;
  let state = null;
  const productCache = new Map();

  function build() {
    dialog = document.createElement('dialog');
    dialog.className = 'bz-qa-dialog';
    dialog.setAttribute('aria-labelledby', 'BzQaTitle');
    dialog.innerHTML =
      '<header class="bz-qa-head"><h2 id="BzQaTitle">Choose your options</h2>' +
      '<button type="button" class="bz-qa-x" data-bz-qa-close aria-label="Close"><svg viewBox="0 0 24 24" aria-hidden="true"><path d="m6 6 12 12M18 6 6 18"/></svg></button></header>' +
      '<div class="bz-qa-body"><div class="bz-qa-top"><img class="bz-qa-img" alt="" width="96" height="96">' +
      '<div class="bz-qa-info"><p class="bz-qa-title"></p><p class="bz-qa-price"><strong></strong> <s></s></p><p class="bz-qa-stock"></p></div></div>' +
      '<div class="bz-qa-options"></div>' +
      '<div class="bz-qa-qty-row"><span>Quantity</span><div class="bz-qa-qty"><button type="button" data-qa-step="-1" aria-label="Decrease quantity">−</button>' +
      '<input type="number" min="1" value="1" inputmode="numeric" aria-label="Quantity"><button type="button" data-qa-step="1" aria-label="Increase quantity">+</button></div></div>' +
      '<p class="bz-qa-error" role="alert"></p></div>' +
      '<footer class="bz-qa-foot"><button type="button" class="bz-qa-add">Add to cart</button><a class="bz-qa-details" href="#">View full details</a></footer>';
    document.body.append(dialog);

    dialog.addEventListener('click', (event) => {
      if (event.target === dialog) {
        const r = dialog.getBoundingClientRect();
        if (event.clientX < r.left || event.clientX > r.right || event.clientY < r.top || event.clientY > r.bottom) dialog.close();
        return;
      }
      if (event.target.closest('[data-bz-qa-close]')) {
        dialog.close();
        return;
      }
      const step = event.target.closest('[data-qa-step]');
      if (step) {
        const input = dialog.querySelector('.bz-qa-qty input');
        input.value = Math.max(1, (parseInt(input.value, 10) || 1) + Number(step.dataset.qaStep));
        return;
      }
      const choice = event.target.closest('[data-qa-option]');
      if (choice && state) {
        state.selected[Number(choice.dataset.qaOption)] = choice.dataset.qaValue;
        render();
        return;
      }
      if (event.target.closest('.bz-qa-add')) add();
    });
  }

  const optionName = (option) => (typeof option === 'string' ? option : option.name);

  function optionValues(index) {
    const option = state.product.options[index];
    if (option && option.values) return option.values;
    return [...new Set(state.product.variants.map((v) => v.options[index]))];
  }

  function variantFor(selected) {
    return state.product.variants.find((v) => v.options.every((value, i) => value === selected[i]));
  }

  function valueAvailable(index, value) {
    return state.product.variants.some(
      (v) => v.available && v.options[index] === value && v.options.every((other, i) => i === index || other === state.selected[i])
    );
  }

  function render() {
    const { product } = state;
    const variant = variantFor(state.selected);
    state.variant = variant;
    const image = (variant && variant.featured_image && variant.featured_image.src) || product.featured_image;
    const img = dialog.querySelector('.bz-qa-img');
    if (image) {
      img.src = sized(image.startsWith('//') ? 'https:' + image : image, 240);
      img.alt = product.title;
      img.hidden = false;
    } else img.hidden = true;
    dialog.querySelector('.bz-qa-title').textContent = product.title;
    const price = variant ? variant.price : product.price;
    const compare = variant ? variant.compare_at_price : product.compare_at_price;
    dialog.querySelector('.bz-qa-price strong').textContent = money(price);
    dialog.querySelector('.bz-qa-price s').textContent = compare > price ? money(compare) : '';
    const stock = dialog.querySelector('.bz-qa-stock');
    stock.textContent = !variant ? 'This combination is unavailable' : variant.available ? 'In stock' : 'Sold out';
    stock.classList.toggle('is-out', !variant || !variant.available);

    const wrap = dialog.querySelector('.bz-qa-options');
    wrap.replaceChildren();
    const hasOptions = !(product.variants.length === 1 && /default title/i.test(product.variants[0].title));
    if (hasOptions) {
      product.options.forEach((option, index) => {
        const name = optionName(option);
        const isColor = /colou?r/i.test(name);
        const group = document.createElement('fieldset');
        group.className = 'bz-qa-group';
        const legend = document.createElement('legend');
        legend.textContent = name + ': ';
        const current = document.createElement('span');
        current.textContent = state.selected[index] || '';
        legend.append(current);
        group.append(legend);
        const list = document.createElement('div');
        list.className = 'bz-qa-values' + (isColor ? ' bz-qa-values--swatch' : '');
        optionValues(index).forEach((value) => {
          const button = document.createElement('button');
          button.type = 'button';
          button.className = 'bz-qa-value';
          button.dataset.qaOption = index;
          button.dataset.qaValue = value;
          button.setAttribute('aria-pressed', String(state.selected[index] === value));
          if (!valueAvailable(index, value)) button.classList.add('is-unavailable');
          const swatchVariant = isColor && product.variants.find((v) => v.options[index] === value && v.featured_image);
          if (swatchVariant) {
            const thumb = document.createElement('img');
            const src = swatchVariant.featured_image.src;
            thumb.src = sized(src.startsWith('//') ? 'https:' + src : src, 120);
            thumb.alt = '';
            thumb.width = 54;
            thumb.height = 54;
            thumb.loading = 'lazy';
            button.append(thumb);
            button.setAttribute('aria-label', value);
            button.title = value;
          } else {
            button.textContent = value;
          }
          list.append(button);
        });
        group.append(list);
        wrap.append(group);
      });
    }

    const addButton = dialog.querySelector('.bz-qa-add');
    const ok = variant && variant.available;
    addButton.disabled = !ok;
    addButton.textContent = ok ? 'Add to cart · ' + money(price) : 'Sold out';
    dialog.querySelector('.bz-qa-details').href = product.url || '/products/' + product.handle;
  }

  async function open(url, opener) {
    if (!dialog) build();
    const clean = String(url).split('?')[0].replace(/\/$/, '');
    opener?.classList.add('is-loading');
    if (opener) opener.disabled = true;
    try {
      let product = productCache.get(clean);
      if (!product) {
        const response = await fetch(clean + '.js', { headers: { Accept: 'application/json' } });
        if (!response.ok) throw new Error('Product unavailable');
        product = await response.json();
        productCache.set(clean, product);
      }
      const first = product.variants.find((v) => v.available) || product.variants[0];
      state = { product, selected: [...first.options], opener };
      dialog.querySelector('.bz-qa-qty input').value = 1;
      dialog.querySelector('.bz-qa-error').textContent = '';
      render();
      if (!dialog.open) dialog.showModal();
      dialog.querySelector('.bz-qa-x').focus({ preventScroll: true });
    } catch (error) {
      window.location.href = clean;
    } finally {
      opener?.classList.remove('is-loading');
      if (opener) opener.disabled = false;
    }
  }

  async function add() {
    if (!state || !state.variant || !state.variant.available) return;
    const button = dialog.querySelector('.bz-qa-add');
    const error = dialog.querySelector('.bz-qa-error');
    const quantity = Math.max(1, parseInt(dialog.querySelector('.bz-qa-qty input').value, 10) || 1);
    button.disabled = true;
    button.textContent = 'Adding…';
    error.textContent = '';
    try {
      const response = await fetch(root() + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({
          items: [{ id: state.variant.id, quantity }],
          sections: 'cart-drawer,cart-icon-bubble',
          sections_url: window.location.pathname,
        }),
      });
      const data = await response.json();
      if (!response.ok || data.status) throw new Error(data.description || data.message || 'Could not add this item.');
      dialog.close();
      const drawer = document.querySelector('cart-drawer');
      if (drawer && data.sections && typeof drawer.renderContents === 'function') {
        drawer.renderContents({ id: state.variant.id, sections: data.sections });
      } else {
        window.location.href = root() + 'cart';
      }
      if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
        publish(PUB_SUB_EVENTS.cartUpdate, { source: 'bezelor-quick-add', productVariantId: state.variant.id });
      }
    } catch (err) {
      error.textContent = err.message;
      render();
    }
  }

  document.addEventListener(
    'submit',
    (event) => {
      const form = event.target.closest && event.target.closest('.bezelor-cart-upsell__form, .bzs-form');
      if (!form) return;
      event.preventDefault();
      event.stopImmediatePropagation();
      const card = form.closest('.bezelor-cart-upsell, .bzs-row');
      const link = card && card.querySelector('.bezelor-cart-upsell__title, .bezelor-cart-upsell__media, .bzs-row__title');
      if (link) open(link.getAttribute('href'), form.querySelector('button'));
    },
    true
  );

  /* warm the product data as soon as a finger or pointer touches an Add button, so the picker opens instantly */
  document.addEventListener('pointerdown', (event) => {
    const form = event.target.closest && event.target.closest('.bzs-form');
    const link = form && form.closest('.bzs-row') && form.closest('.bzs-row').querySelector('.bzs-row__title');
    if (!link) return;
    const clean = String(link.getAttribute('href')).split('?')[0].replace(/\/$/, '');
    if (productCache.has(clean)) return;
    fetch(clean + '.js', { headers: { Accept: 'application/json' } }).then((r) => (r.ok ? r.json() : null)).then((p) => { if (p) productCache.set(clean, p); }).catch(() => {});
  }, true);

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', watchCart);
  else watchCart();
})();
